module.exports = __webpack_public_path__ + "media/images/logo/payment_channel/virtual_account_mandiri-65766d07ffc3d6c30bf2ecdf19ef44c6.svg";